import '../typedefs'
import http from '@/http'

export default {
    /**
     * @param {SearchQuery} query
     * @returns {Promise<void>}
     */
    async searchMetricTypes (query) {
        try {
            const response = await http.get('products/metrics', {
                params: query
            })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ProductQuery} data
     * @returns {Promise<void>}
     */
    async showMetricType (data) {
        try {
            const response = await http.get(`/products/metrics/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {MetricType} data
     * @returns {Promise<void>}
     */
    async createMetricType (data) {
        try {
            const response = await http.post('/products/metrics', data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {MetricType} data
     * @returns {Promise<void>}
     */
    async updateMetricType (data) {
        try {
            const response = await http.put(`/products/metrics/${data.id}`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {MetricType} data
     * @returns {Promise<void>}
     */
    async removeMetricType (data) {
        try {
            const response = await http.delete(`/products/metrics/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
